export const HEADING = 'Tell us a bit about your health';
export const SUBHEADING =
  "This information helps us get your accurate rate from America's top insurance companies.";
export const TITLE = 'Health';
